import { AvailableTimeslot } from 'entities/Form';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Skeleton from 'react-loading-skeleton';
import { areDatesSame } from 'utils/helper';
import styles from './TimePicker.module.scss';

interface TimePickerProps {
  selectedDate?: Date;
  selectedTime?: string;
  availableTimeslots: AvailableTimeslot[] | undefined;
  onSelect: (fromDt: string, toDt: string) => void;
  twoColumns?: boolean;
}

const TimePicker: FC<TimePickerProps> = ({ selectedDate, selectedTime, availableTimeslots, onSelect, twoColumns }) => {
  const { t, i18n } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.title}>{t('availableTimeSlotsLabel')}</div>
      {selectedDate ? (
        <div className={`${styles.times} ${twoColumns && styles.fourColumns}`}>
          {availableTimeslots ? (
            availableTimeslots.length > 0 ? (
              availableTimeslots.map((time, index) => (
                <button
                  key={index}
                  className={`${styles.time} ${
                    selectedTime && selectedTime === time.fromDt && areDatesSame(selectedDate, new Date(time.fromDt))
                      ? styles.selected
                      : ''
                  }`}
                  onClick={() => onSelect(time.fromDt, time.toDt)}>
                  {i18n.language === 'zh-CN'
                    ? time.labelSc
                    : i18n.language === 'zh-TW' || i18n.language === 'zh-HK'
                    ? time.labelTc
                    : time.label}
                </button>
              ))
            ) : (
              <span>{t('noTimeSlot')}</span>
            )
          ) : (
            <>
              <Skeleton height={32} borderRadius={'16px'} />
              <Skeleton height={32} borderRadius={'16px'} /> <Skeleton height={32} borderRadius={'16px'} />
              <Skeleton height={32} borderRadius={'16px'} /> <Skeleton height={32} borderRadius={'16px'} />
            </>
          )}
        </div>
      ) : (
        <span>{t('pleaseSelectDate')}</span>
      )}
    </div>
  );
};

export default TimePicker;
